import { render } from "./HomePagePart1ArtistsNews.vue?vue&type=template&id=47ce647c"
import script from "./HomePagePart1ArtistsNews.vue?vue&type=script&lang=js"
export * from "./HomePagePart1ArtistsNews.vue?vue&type=script&lang=js"

import "./HomePagePart1ArtistsNews.vue?vue&type=style&index=0&id=47ce647c&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__